import React from 'react';
import { List } from 'antd';
import { FormOutlined } from '@ant-design/icons';
import AppIconGroup from '../../components/app-icon-group';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    const [roles, setRoles] = React.useState([]);

    const getRoles = async () => {
        const response = await fetch('/api/account/role/list');
        const result = await response.json();

        if (result && result.success) {
            setRoles(result.data);
        }
    }

    React.useEffect(() => {
        getRoles();
    }, []);

    return (
        <div>
            {/* 快捷操作 - iOS 风格图标组 */}
            <div className="mt-3 mb-4">
                <AppIconGroup 
                    items={[
                        {
                            id: 1,
                            href: '/account/role-create',
                            title: '创建角色',
                            icon: <FormOutlined />,
                            color: 'from-blue-500 to-blue-600'
                        }
                    ]}
                    cols="3-3-3-3-3"
                />
            </div>
            
            <h2 className="admin-page-title">角色列表</h2>
            <List bordered>
                {
                    roles && roles.map((item, index) => {
                        const actions = [];
                        if (item.roleCode !== 'SUPER_ADMIN') {
                            actions.push(<a href={`/account/role-create?roleId=${item.roleId}`}>编辑</a>);
                        }
                        return <List.Item key={item.roleId}
                            actions={actions}
                        >
                            <div>{item.roleTitle}</div>
                        </List.Item>
                    })
                }
            </List>
            {
                (!roles || roles.length === 0) && <div className="text-center py-5">暂无角色，<a href='/account/role-create'>创建角色</a></div>
            }
        </div>
    )
}